// @ts-strict-ignore
import React from 'react'
import { isEmpty, map, orderBy } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import { Button, Chip, Box as OuterWrapper } from '@node-space/ui-components'
import useFilterFromTo from 'components/FilterBar/hooks/useFilterFromTo'
import useFilterMerchant from 'components/FilterBar/hooks/useFilterMerchant'
import useFilterParams from 'components/FilterBar/hooks/useFilterParams'
import useFilterStatus from 'components/FilterBar/hooks/useFilterStatus'
import useFilterTag from 'components/FilterBar/hooks/useFilterTag'

const FilterResetList = ({ executor }) => {
  const { t } = useTranslation()
  const { filterCount } = useFilterParams()
  const { resetDateRange } = useFilterFromTo()
  const { resetStatus } = useFilterStatus()
  const { resetMerchant } = useFilterMerchant()
  const { resetTag } = useFilterTag()

  const onResetListClose = (name: string) => {
    if (name === 'date') {
      resetDateRange()
    }

    if (name === 'status') {
      resetStatus()
    }

    if (name === 'merchant') {
      resetMerchant()
    }

    if (name === 'tag') {
      resetTag()
    }

    setTimeout(() => {
      executor()
    }, 0)
  }

  const orderedFilterList =
    orderBy(filterCount, ['order']).filter(filter => filter?.name !== 'search') || []

  const handleClearAll = () => {
    resetDateRange()
    resetStatus()
    resetMerchant()
    resetTag()

    setTimeout(() => {
      executor()
    }, 0)
  }

  return (
    <>
      {!isEmpty(orderedFilterList) && (
        <OuterWrapper testId="filter-bar-reset" className="flex flex-row mt-3 gap-x-3 items-center">
          {map(orderedFilterList, filter => {
            return (
              <Chip
                key={uuidv4()}
                label={filter?.value}
                name={filter?.name}
                variant="input"
                dismissible={true}
                onClose={() => onResetListClose(filter?.name)}
              />
            )
          })}
          <Button
            testId="filter-clear-all-button"
            variant="ghost"
            noPadding
            onClick={handleClearAll}
          >
            {t('clear')}
          </Button>
        </OuterWrapper>
      )}
    </>
  )
}

export default FilterResetList
